/* eslint-disable */
import pjson from '../package.json';

const getEnvironmentVariables = (env) => {
  switch (env) {
    case 'DEV':
      return {
        API_URL: 'http://3.38.190.148:57793/v1/',
        IAPI_URL: 'https://s-iapi.circul.us/v1/',
        CALL_URL: 'https://3.34.146.103:8089/janus',
        IOT_URL: 'wss://d-proxy.circul.us:8443',
        SITE_URL: 'http://3.38.190.148:57201/',
        RAPI_URL: 'https://dev-rapi.circul.us/v1/',
        DEV_MODE: true,
      };
    case 'STG':
      return {
        API_URL: 'https://s-papi.circul.us/v1/',
        IAPI_URL: 'https://s-iapi.circul.us/v1/',
        CALL_URL: 'https://s-webrtc.circul.us/janus',
        IOT_URL: 'wss://s-proxy.circul.us:8443',
        SITE_URL: 'https://s-manager.circul.us/',
        RAPI_URL: 'https://s-rapi.circul.us/v1/',
        DEV_MODE: false,
      };
    case 'OPS':
      return {
        API_URL: 'https://o-papi.circul.us/v1/',
        IAPI_URL: 'https://api-intgr.circul.us/v1/',
        CALL_URL: 'https://o-webrtc.circul.us/janus',
        IOT_URL: 'wss://o-proxy.circul.us:8443',
        SITE_URL: 'https://manager.circul.us/',
        RAPI_URL: 'https://o-rapi.circul.us/v1/',
        DEV_MODE: false,
      };
    default:
      // 'LOCAL'
      return {
        // API_URL: 'https://o-papi.circul.us/v1/',
        CALL_URL: 'https://o-webrtc.circul.us/janus',
        IOT_URL: 'wss://o-proxy.circul.us:8443',
        SITE_URL: 'http://localhost:3000/',
        RAPI_URL: 'https://o-rapi.circul.us/v1/',
        // API_URL: 'https://s-papi.circul.us/v1/',
        API_URL: 'http://192.168.31.159:57793/v1/',
        IAPI_URL: 'http://localhost:59730/v1/',
        // CALL_URL: 'https://s-webrtc.circul.us/janus',
        // IOT_URL: 'wss://s-proxy.circul.us:8443',
        // SITE_URL: 'https://s-manager.circul.us/',
        // RAPI_URL: 'https://s-rapi.circul.us/v1/',
        DEV_MODE: true,
      };
  }
};

export const environment = 'OPS'; // || 'LOC';
export const publishDate = '26006041302';
console.log(`${environment} / ${pjson.version}`, 'config');
export const MAP_CLIENT_ID = '2hqmcff0c3';

export const {
  IOT_URL,
  API_URL,
  IAPI_URL,
  CALL_URL,
  SITE_URL,
  RAPI_URL,
  DEV_MODE,
} = getEnvironmentVariables(environment);
